import { render } from "./indexelevenfacts.vue?vue&type=template&id=671acc73"
import script from "./indexelevenfacts.vue?vue&type=script&lang=js"
export * from "./indexelevenfacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__